module.exports = __webpack_public_path__ + "45e4a421a0b5b7b34b95f0660a6a777a.svg";